













import {Component, Emit, Model, Prop, Vue} from "vue-property-decorator";

@Component({
    name: "InputCurrency"
})
export default class extends Vue {
    @Prop({ default: "", type: String })
    readonly placeholder!: string;
    @Prop({default: 'default'}) readonly size!: 'default' | 'small' | 'large';

    @Prop({ default: false, type: Boolean })
    readonly disabled!: boolean;

    @Prop({ default: 0, type: Number })
    readonly min!: number;

    @Model("change")
    readonly number!: number;

    @Emit("change")
    onChange(value: any) {
        return value;
    }
}
